import React from 'react';
import ResaleBreakdown from './components/resaleBreakdown';
import './resale.css';

// We have to do this way because there's a fake step that prevents us from using a regular form structure.
export default function ResaleTicketForm({ onSubmit = () => { }, config }) {
    const min = config['resale-ticket-form'].resale_breakdown.price.min;
    const max = config['resale-ticket-form'].resale_breakdown.price.max;
    const [state, setState] = React.useState({ 'price': min === max ? max : null, 'is_private_resale': Boolean(config['resale-ticket-form'].resale_option.value) });

    const handleSubmit = React.useCallback(() => {
        onSubmit({
            data: state
        })
    }, [onsubmit, state])

    return (
        <div className='resale-container'>
            <ResaleBreakdown data={config['resale-ticket-form']} state={state} setState={setState} onSubmit={onSubmit} handleSubmit={handleSubmit} />
        </div>
    )
}